import { css } from "styled-components";
import { getPropertyByMedia } from "../helpers";
export const getHeightBySize = (size) => {
    const sizeParser = {
        small: "32px",
        medium: "40px",
        large: "48px",
    };
    const getPropertyValue = (values) => getPropertyByMedia("height", values, sizeParser.medium);
    if (typeof size === "object") {
        const parsedSizes = size;
        parsedSizes.small &&= sizeParser[parsedSizes.small];
        parsedSizes.medium &&= sizeParser[parsedSizes.medium];
        parsedSizes.large &&= sizeParser[parsedSizes.large];
        return getPropertyValue(parsedSizes);
    }
    return getPropertyValue(sizeParser[size]);
};
export const buttonVariant = {
    primary: css `
		background-color: var(--button-primary-default-background);

		&:not([data-loading='true'], :disabled):hover {
			background-color: var(--button-primary-hover-background);
		}

		i,
		p {
			color: var(--button-primary-color);
		}

		.loading-fragment {
			border-color: var(--button-primary-color) transparent transparent transparent;
		}
	`,
    secondary: css `
		background-color: var(--button-secondary-default-background);
		border: 1px solid var(--button-secondary-default-border-color);

		&:not([data-loading='true'], :disabled):hover {
			background-color: var(--button-secondary-hover-background);
			border: 1px solid var(--button-secondary-hover-border-color);

			i,
			p {
				color: var(--button-secondary-hover-color);
			}
		}

		i,
		p {
			color: var(--button-secondary-default-color);
		}

		.loading-fragment {
			border-color: var(--button-secondary-default-color) transparent transparent transparent;
		}
	`,
    text: css `
		background-color: var(--button-text-default-background);

		&:not([data-loading='true'], :disabled):hover {
			background-color: var(--button-text-hover-background);
		}

		i,
		p {
			color: var(--button-text-color);
		}

		.loading-fragment {
			border-color: var(--button-text-color) transparent transparent transparent;
		}
	`,
    none: css `
		padding: 0;
		height: fit-content;
	`,
};
//# sourceMappingURL=helpers.js.map